/** The uppercase section label: MOVES · RATING · OPPONENT · QUICK PLAY. */
import React from 'react';
import {StyleProp, TextStyle} from 'react-native';

import Txt from './Txt';

function Kicker({text, style}: {text: string; style?: StyleProp<TextStyle>}) {
  return (
    <Txt variant="kicker" tone="muted" style={style}>
      {text}
    </Txt>
  );
}

export default React.memo(Kicker);
